import { Colors } from "../../utils/styles";

const styles =  {
    bodyContainer: {
        marginTop: 50
    },
    signInHeaderText: {
        fontWeight: 600,
        fontSize: 20,
        color: "#000000",
        textAlign: "center",
        marginTop: 40
    },
    signInForm: {
        marginTop: 40
    },
    signInFormContainer: {
        marginBottom: 20
    },
    signInFormLabel: {
        fontWeight: 500,
        fontSize: 16,
        color: "#181743",
    },
    formInput: {
        borderRadius: 8,
        border: "1px solid #BEBDFF",
        height: 46,
        margin: "0 auto",
        width: "100%",
    },
    button: {
        width: 380,
        height: 53,
        margin: "40px auto auto auto",
        display: "block",
        background: Colors.BES_PURPLE,
        border: "none"
    },
};

export default styles;